/**
 * Created by rickborst on 24/04/2017.
 */

import _ from 'lodash';

import Config from 'config';

import {default as Rail, RailTypes} from 'models/rail';

import {convertAssetsFromRead} from './assets';

const RailTypeMap = {
    'rge:rail:type:001': RailTypes.LANDSCAPE,
    'rge:rail:type:002': RailTypes.LANDSCAPE_MORE,
    'rge:rail:type:003': RailTypes.SPORTS,
    'rge:rail:type:004': RailTypes.GRID_PORTRAIT,
    'rge:rail:type:005': RailTypes.GRID_LANDSCAPE,
    'rge:rail:type:006': RailTypes.GRID_PORTRAIT_FILTER,
    'rge:rail:type:007': RailTypes.MATCH_SCHEDULE,
    'rge:rail:type:008': RailTypes.JUMBO,
    'rge:rail:type:009': RailTypes.UNKNOWN, // Deprecated
    'rge:rail:type:010': RailTypes.PORTRAIT,
    'rge:rail:type:011': RailTypes.LEAGUES,
    'rge:rail:type:012': RailTypes.MINI_EPG,
    'rge:rail:type:013': RailTypes.EPG,
    'rge:rail:type:014': RailTypes.LANDSCAPE_ALL_CHANNELS
};

/**
 * Returns the rail type.
 *
 * @param {string} railDescription - Rail description.
 * @returns {string} Rail type.
 */
function getRailType (railDescription) {
    let parts = railDescription.split('|');

    return RailTypeMap[parts[0]] || RailTypeMap.UNKNOWN;
}

/**
 * Returns the more value.
 *
 * @param {string} railDescription - Rail description.
 * @returns {string} More value.
 */
function getMore (railDescription) {
    let parts = railDescription.split('|');

    return parts[1] || '';
}

/**
 * Converts channel data from read data.
 *
 * @param {Object} channel - Read data.
 * @returns {Object} Channel data.
 */
function convertFromReadRail (channel = {}) {

    return {
        id: channel.id || '',
        title: channel.name || '',
        images: channel.images || [],
        type: getRailType(channel.description),
        more: getMore(channel.description),
        apiSpecifics: {
            objectType: channel.objectType || '',
            order: channel.order || ''
        }
    };
}

/**
 * Converts rail data for prepare rail request.
 *
 * @param {{rail: Object, amount: number, page: number}} config - Rail and pagination data.
 * @returns {Object} Prepare rail request data.
 */
function convertForPrepareRail (config) {
    const apiConfig = Config.dataSources.kaltura,
        {rail, pageSize, pageIndex} = config;

    return {
        filter: {
            'objectType': 'KalturaChannelFilter',
            'idEqual': rail.id
        },
        pager: {
            'pageSize': pageSize || 30,
            'pageIndex': pageIndex || 1
        },
        apiVersion: apiConfig.APIVersion
    };
}

/**
 * Converts rail data from prepare rail data.
 *
 * @param {Object} [data] - Prepare rail data.
 * @returns {Array} Rail data.
 */
function convertFromPrepareRail (data = {}) {
    let rawData = _.get(data, ['result']) || [],
        {objects, totalCount} = rawData;

    return {
        totalCount,
        assets: convertAssetsFromRead.call(this, objects)
    };
}

/**
 * Converts rails data for prepare rails request.
 *
 * @param {Array} rails - Rails of the view.
 * @param {any} params - Params object.
 * @returns {Object} Prepare rails request data.
 */
function convertForPrepareRails (rails, params = {}) {
    const apiConfig = Config.dataSources.kaltura,
        {pagination = {}} = params;

    let requestPayload = {
            apiVersion: apiConfig.APIVersion
        },
        i,
        l;

    for (i = 1, l = rails.length; i <= l; i++) {

        requestPayload[i] = {
            service: 'asset',
            action: 'list',
            filter: {
                'objectType': 'KalturaChannelFilter',
                'idEqual': rails[i - 1].id
            },
            pager: {
                'pageSize': pagination.pageSize || 30,
                'pageIndex': pagination.pageNumber || 1
            }
        };

        if (rails[i - 1].type === RailTypes.MINI_EPG) {
            requestPayload[i].filter.orderBy = 'START_DATE_ASC';
        }
    }

    return requestPayload;
}

/**
 * Converts rails data from prepare rails data.
 *
 * @param {Object} [data] - Prepare rails data.
 * @returns {Array} Rails data.
 */
function convertFromPrepareRails (data) {
    let rawData = _.get(data, ['result']) || [],
        parsedData = [];

    rawData.forEach((rawRailData) => {

        parsedData.push(convertAssetsFromRead.call(this, rawRailData.objects));
    });

    return parsedData;
}

/**
 * Groups any filter grid rails and puts them as assets into a single GRID_PORTRAIT_FILTER rail.
 *
 * @param {Array} rails - Array of rails.
 * @returns {Array} Array of rails.
 */
function groupFilterGridRails (rails) {

    let i = 0,
        index,
        groups = _.groupBy(rails, rail => {
            let result = rail.type === RailTypes.GRID_PORTRAIT_FILTER;

            if (result && _.isUndefined(index)) {
                index = i;
            }

            i++;

            return result;
        }),
        filterGrids,
        nonFilterGrids;

    if (_.isUndefined(index)) {
        return rails;
    }

    filterGrids = groups[true];
    nonFilterGrids = groups[false];

    index = Math.min(index, filterGrids.length);

    nonFilterGrids[index] = new Rail({
        id: 'filtered_rails',
        title: '',
        images: [],
        type: RailTypes.GRID_PORTRAIT_FILTER,
        more: '',
        apiSpecifics: {}
    });

    nonFilterGrids[index].assets = filterGrids;

    return nonFilterGrids;
}

export {
    convertFromReadRail,
    convertForPrepareRail,
    convertFromPrepareRail,
    convertForPrepareRails,
    convertFromPrepareRails,
    groupFilterGridRails
};


// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/adapters/rails.js